export const BOLD = "bold";
export const ITALIC = "italic";
export const UNDERLINE = "underline";
export const CODE = "code";
export const STRIKETHROUGH = "strikethrough";
export const LINK = "link";

export const H1 = "heading-one";
export const H2 = "heading-two";
export const H3 = "heading-three";
export const H4 = "heading-four";
export const H5 = "heading-five";
export const H6 = "heading-six";
export const PARAGRAPH = "paragraph";
export const BLOCK_QUOTE = "block-quote";
export const CODE_BLOCK = "code-block";
export const CODE_LINE = "code-line";
export const NOTE = "note";
export const IMAGE = "image";
export const BULLETED_LIST = "bulleted-list";
export const NUMBERED_LIST = "numbered-list";
export const LIST_ITEM = "list-item";
export const HR = "hr";

export const TOOL_BUTTON = "tool-button";
export const HOT_KEY = "hot-key";
export const SHORT_CUTS = "short-cuts";

export const REDO = "redo";
export const UNDO = "undo";
